<script>
  export let item = undefined;
</script>

<style>
  .item {
    cursor: pointer;
    padding: 4px 10px;
    font-size: 1em;
    line-height: auto;
  }
</style>

<div class="item">
  {item.gps_code}
  {#if item.gps_code}-{/if}
  {item.name}
</div>
